import React, { useState } from 'react'
import { Button, H2, NoneLabel, SectionContainer } from 'components/shared'
import SportForm, { initialState } from './SportForm/SportForm'
import styles from './SportPoll.module.scss'
import { PopupContainer } from 'components'
import SportPollTable from './SportPollTable/SportPollTable'
import { SportPoll as SportPollType } from './SportForm/types'
import cl from 'classnames'

const SportPoll = () => {
  const [showForm, setShowForm] = useState(false)
  const [editSportForm, setEditSportForm] = useState<SportPollType>({
    startTime: '',
    endTime: '',
    resultTime: '',
    question: '',
    options: [],
    answer: '',
    projectId: 0
  })
  const isCreate = window.location.pathname.includes('create')

  return (
    <SectionContainer className={styles.sportPollContainer}>
      <div className={styles.header}>
        <H2>Polls</H2>
        <Button
          preset='secondary'
          onClick={() => setShowForm(!showForm)}
          disabled={isCreate}
        >
          Add a poll
        </Button>
      </div>
      <div>
        {isCreate && <NoneLabel label='Please create project first then you can add poll here.'></NoneLabel> }
      </div>

      {showForm &&
        <PopupContainer
          onClose={() => {
            setShowForm(false)
            setEditSportForm(initialState)
          }}
          title={''}
        >
          <div className={cl(styles.sportPollScrollableContainer, styles.thinScroll)}>
            <SportForm EditSportForm={editSportForm}/>
            <SportPollTable onEditSportForm={setEditSportForm} />
          </div>

        </PopupContainer>}
    </SectionContainer>
  )
}

export default SportPoll
